import { Eye, EyeOff } from "lucide-react";
import React, { useState } from "react";
import { cn } from "../../lib/utils";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  className?: string;
  error?: string;
}

const AppInputField: React.FC<InputProps> = ({
  label,
  className,
  error,
  type,
  ...props
}) => {
  const isPassword = type === "password";
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="flex flex-col gap-1 mb-2 text-[13px]">
      {label && <label className="font-semibold mb-2">{label}</label>}

      <div className="relative">
        <input
          {...props}
          type={isPassword && showPassword ? "text" : type}
          className={cn(
            "w-full bg-[#F6F6F6] border-[#F6F6F6] h-[48px] px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all pr-12",
            className
          )}
        />

        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword((prev) => !prev)}
            className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700"
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? (
              <EyeOff className="h-4 w-4" />
            ) : (
              <Eye className="h-4 w-4" />
            )}
          </button>
        )}
      </div>

      {error && <span className="text-red-500 text-[13px] mt-1">{error}</span>}
    </div>
  );
};

export default AppInputField;
